import styled from 'styled-components';
import {
  ContainerProps,
  CounterProps,
  ExplosionProps,
  MultiplierProps,
  RocketProps,
} from './props';

import { Image as NextImage } from '@starsoft/common/components';
import { css } from 'styled-components';

export const Rocket = styled.div<RocketProps>`
  width: 100%;
  max-width: 180px;
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  transform: ${({ animate }) =>
    animate ? 'translateY(-120px)' : 'translateY(60px)'};
  transition: all 0.3s;
  transition-delay: 0.3s;
  z-index: 1;

  @media (max-width: 768px) {
    max-width: 110px;
    transform: ${({ animate }) =>
      animate ? 'translateY(-120px)' : 'translateY(20px)'};
  }
`;

export const Explosion = styled.div<ExplosionProps>`
  width: 100%;
  max-width: 250px;
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  transform: translateY(-150px);
  opacity: 0.9;
  z-index: 1;

  @media (max-width: 768px) {
    max-width: 140px;
    transform: translateY(-140px);
  }
`;

export const RocketWaitingAnimation = styled.div<RocketProps>`
  width: 100%;
  max-width: 250px;
  display: ${({ visible }) => (visible ? 'flex' : 'none')};
  transform: translateY(40px);

  @media (max-width: 768px) {
    max-width: 140px;
  }
`;

export const Multiplier = styled.div<MultiplierProps>`
  width: fit-content;
  font-size: 32px;
  font-weight: 600;
  color: ${({ theme, won, isPlaying }) =>
    isPlaying && won
      ? theme.vars.palette.success.main
      : theme.vars.palette.text.primary};
  position: absolute;
  left: 50%;
  top: 15%;
  transform: translate(-50%, -15%);
  z-index: 4;
`;

export const MoonImage = styled(NextImage)`
  width: 100%;
  max-width: 600px;
  position: absolute;
  top: -30%;
  z-index: 0;
  right: -20%;
  z-index: 0;
  transition: all 0.3s;

  @media (max-width: 768px) {
    top: -80%;
    right: -30%;
  }
`;

export const UfoImage = styled(NextImage)`
  width: 100%;
  max-width: 100px;
  position: absolute;
  z-index: 0;
  left: 0%;
  top: 15%;
  z-index: 0;
  animation: bounce 3s infinite;

  @keyframes bounce {
    0% {
      margin-top: 0;
    }
    50% {
      margin-top: 10px;
    }
    100% {
      margin-top: 0;
    }
  }

  @media (max-width: 768px) {
    max-width: 80px;
    top: -35%;
  }
`;

export const SatelliteImage = styled(NextImage)`
  width: 100%;
  max-width: 100px;
  position: absolute;
  right: 15%;
  z-index: 0;
  bottom: 15%;

  @media (max-width: 768px) {
    right: 5%;
  }
`;

export const LastBetContainer = styled.div`
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  padding: 16px;
  z-index: 5;
`;

export const Container = styled.div<ContainerProps>`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  min-height: 300px;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.vars.shape.borderRadius};
  background-image: ${() =>
    `url('${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/limbo/bg.png')`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  @media (max-width: 768px) {
    min-height: 300px;
  }

  ${({ isSecondaryStyles }) =>
    isSecondaryStyles &&
    css`
      min-height: 300px;

      ${Rocket} {
        max-width: 140px;
        transform: translateY(-80px);
      }

      ${Explosion} {
        max-width: 140px;
        transform: translateY(-80px);
      }

      ${RocketWaitingAnimation} {
        max-width: 140px;
      }

      ${MoonImage} {
        top: -80%;
        right: -30%;
      }

      ${UfoImage} {
        max-width: 80px;
        top: -35%;
      }

      ${SatelliteImage} {
        right: 5%;
      }
    `}
`;

export const Counter = styled.div<CounterProps>`
  position: absolute;
  left: 50%;
  top: 15%;
  transform: translate(-50%, -15%);
  font-size: 64px;
  z-index: 2;
  font-weight: 600;
  color: ${({ won, theme }) =>
    won ? 'rgb(6, 227, 133)' : theme.vars.palette.text.primary};

  @media (max-width: 768px) {
    font-size: 38px;
  }
`;
